<template>
    <Fragment>
        <div v-for="c in catches" :key="c.Id">
            <CatchCard :catchData="c" />
        </div>
        <EndlessScroll :ignoreEnd="isLoading" :onEndIsNear="() => loadCatchesFromKey(key)" />
    </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { mapState, mapActions } from 'vuex';
import { Bus, Stops } from '../../common/bus';
import CatchCard from './CatchCard.vue';
import EndlessScroll from '../common/EndlessScroll.vue';

export default {
    components: { CatchCard, Fragment, EndlessScroll },
    computed: {
        ...mapState('catches', ['isLoading', 'key', 'catches']),
    },
    async created() {
        Bus.$emit(Stops.NAVBAR, 'CatchList');
    },
    methods: {
        ...mapActions('catches', ['loadCatchesFromKey']),
    },
};
</script>

<style lang="scss"></style>
